<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ORIM-Dedication">As a teenager, the Anglo-Irish painter Francis Bacon was sent to Weimar Berlin with an uncle, but that fact has been surrounded by pure fiction. The characters and events <a id="_idTextAnchor000"></a>are wholly imaginary and any resemblance to persons living or dead is truly coincidental. </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Law_NightsInBerlin_3P_MD4.vue?3bfaded0